<template>
  <div id="bannerDescription" class="w-full relative">
    <title-w-star :title="title" :titleColor="titleColor" :starIconObj="starIconObj" />

    <div class="absolute left-0" style="width: 9.5vw" :style="starBackgroundObj.position" v-if="Object.keys(starBackgroundObj).length != 0">
      <img :src="commonStore.getImgUrl(starBackgroundObj.componentName, starBackgroundObj.imgName, starBackgroundObj.imgFormat)" />
    </div>

    <div class="flex flex-col items-center" style="width: 60vw; margin: auto">
      <img :src="commonStore.getImgUrl(imgObj.componentName, imgObj.imgName, imgObj.imgFormat)" :class="[description != '' ? 'mb-8' : '']" style="width: inherit" v-if="Object.keys(imgObj).length != 0" />
      <div v-html="t(description)" class="font-jost text-2xl text-center" :style="'color:' + descColor" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from "vue";
import { useCommonStore } from "@/stores/common";
import { useI18n } from "vue-i18n";

const commonStore = useCommonStore();
const { t, locale } = useI18n();

onMounted(async () => {});

import { toRefs } from "vue";

const props = defineProps({
  title: {
    type: String,
    default: "",
  },
  titleColor: {
    type: String,
    default: "#494949",
  },
  starIconObj: {
    type: Object,
    default: {},
    //{ componentName: 'telemedicine', imgName: 'starIconLightBlue', imgFormat: 'svg' }
  },
  starBackgroundObj: {
    type: Object,
    default: {},
    //{ componentName: 'telemedicine', imgName: 'starIconLightBlue', imgFormat: 'svg',   }
  },
  imgObj: {
    type: Object,
    default: {},
    //{ componentName: 'telemedicine', imgName: 'starIconLightBlue', imgFormat: 'svg',   }
  },
  description: {
    type: String,
    default: "",
  },
  descColor: {
    type: String,
    default: "#494949",
  },
});
//const { label } = toRefs(props);
</script>

<style>
</style>